import axios from "axios";
import { Form, Modal, Button } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";
import { Base_URL } from "../../helpers/constants";
import useAuth from "../../hooks/useAuth";

function AddProfileModal({ open, onClose }) {
  const { auth } = useAuth();
  if (!open) return null;

  const token = auth.accessToken;

  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

  const schema = yup.object().shape({
    name: yup.string().required(),
    www: yup.string().url().required(),
    logoUrl: yup.string().url(),
    languages: yup
      .array()
      .of(yup.string())
      .min(1, "Vsaj 1 jezik mora biti izbran"),
    webShopModule: yup.bool(),
  });

  const languages = ["SL", "EN", "HR", "DE", "SR"];

  return (
    <div>
      <Modal show={open} onHide={onClose} role="document">
        <Formik
          validationSchema={schema}
          onSubmit={(data) => {
            axios({
              method: "POST",
              url: `${Base_URL}createVendor`,
              data: data,
            })
              .then(function (res) {
                alert("Podjetje uspešno dodano!");
                onClose();
              })
              .catch(function (res) {
                console.log(res);
              });
          }}
          initialValues={{
            name: "",
            www: "",
            logoUrl: "",
            languages: [],
            webShopModule: false,
          }}
        >
          {({ handleSubmit, handleChange, values, touched, errors }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Modal.Header>
                <Modal.Title>Dodajanje enote</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group>
                  <Form.Label for="nameInput">Naziv</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    id="nameInput"
                    placeholder="Vnesi naziv"
                    value={values.name}
                    className="form-control"
                    onChange={handleChange}
                    isValid={touched.name && !errors.name}
                    isInvalid={!!errors.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group>
                  <Form.Label for="wwwInput">Spletno mesto</Form.Label>
                  <Form.Control
                    type="url"
                    name="www"
                    id="wwwInput"
                    placeholder="Vnesi URL spletnega mesta"
                    value={values.www}
                    className="form-control"
                    onChange={handleChange}
                    isValid={touched.www && !errors.www}
                    isInvalid={!!errors.www}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.www}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group>
                  <Form.Label for="logoInput">URL logotipa</Form.Label>
                  <Form.Control
                    type="text"
                    name="logoUrl"
                    id="logoInput"
                    placeholder="Vnesi URL logotipa"
                    value={values.logoUrl}
                    className="form-control"
                    onChange={handleChange}
                    isValid={touched.logoUrl && !errors.logoUrl}
                    isInvalid={!!errors.logoUrl}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.logoUrl}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Label for="languagesInput">
                  Jeziki podjetja &nbsp;{" "}
                </Form.Label>
                {languages.map((language) => (
                  <Form.Check
                    key={language}
                    type="checkbox"
                    label={language}
                    id="languagesInput"
                    name="languages"
                    value={language}
                    checked={values.languages.includes(language)}
                    onChange={handleChange}
                    isInvalid={touched.languages && !!errors.languages}
                    className="form-check-inline"
                  />
                ))}

                <Form.Control.Feedback type="invalid">
                  {errors.languages}
                </Form.Control.Feedback>

                {/*
                <Form.Group>
                  <Form.Check
                    type="checkbox"
                    value={values.webShopModule}
                    class="form-check-input"
                    label="Podjetje je spletna trgovina"
                    onChange={handleChange}
                    isValid={touched.webShopModule && !errors.webShopModule}
                    isInvalid={!!errors.webShopModule}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.webShopModule}
                  </Form.Control.Feedback>{" "}
                  <Form.Text>
                    Spletni trgovini se avtomatsko kreira modul{" "}
                    <span className="font-italic">produkti</span>
                  </Form.Text>
                </Form.Group>
          */}
              </Modal.Body>
              <Modal.Footer>
                <Button type="submit">Dodaj</Button>{" "}
                <Button type="button" variant="secondary" onClick={onClose}>
                  Prekliči
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
}
export default AddProfileModal;
